import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly TOKEN_KEY = 'JWTToken';
  private tokenSubject = new BehaviorSubject<string | null>(
    localStorage.getItem(this.TOKEN_KEY)
  );

  token$ = this.tokenSubject.asObservable();

  get token(): string | null {
    return this.tokenSubject.value;
  }

  setToken(token: string) {
    this.tokenSubject.next(token);
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  clearToken() {
    this.tokenSubject.next(null);
    localStorage.removeItem(this.TOKEN_KEY);
  }

  hasToken(): boolean {
    return !!this.token;
  }
}
